import classNames from 'classnames';
import ListSkeleton from './ListSkeleton';
import TableSkeleton from './TableSkeleton';

interface Props {
  size?: number;
  columns?: number;
  rows?: number;
  variant: 'list' | 'table';
  'aria-label': string;
}

function LoadingState({ variant, 'aria-label': ariaLabel, size, columns, rows }: Props) {
  return (
    <div className={classNames('empty-loading-state', `empty-loading-state--${variant}`)} data-testid="loading-state">
      {variant === 'list' && <ListSkeleton isLoading aria-label={ariaLabel} size={size} />}

      {variant === 'table' && <TableSkeleton isLoading aria-label={ariaLabel} columns={columns} rows={rows} />}
    </div>
  );
}

export default LoadingState;
